import { type Nil, isNil } from "@mcwd/typescript-type-guards";
import { parseNumber } from "./parseNumber.js";



export function parseInteger (value: unknown, { parseFromBoolean = false } = {}): number | Nil
{
  const parsedNum = parseNumber(value, { parseFromBoolean });
  if (isNil(parsedNum)) {
    return parsedNum;
  }
  return (parsedNum % 1) === 0 ? parsedNum : null;
}
